var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    {
      staticClass: "quick-favorite be-quick-favorite video-toolbar-left-item",
      class: { on: _vm.isFavorite, ..._vm.displayModeClass },
      attrs: { title: "快速收藏" },
      on: {
        click: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "left", 37, $event.key, [
              "Left",
              "ArrowLeft",
            ])
          )
            return null
          if ("button" in $event && $event.button !== 0) return null
          if ($event.target !== $event.currentTarget) return null
          return _vm.toggle()
        },
        contextmenu: function ($event) {
          $event.preventDefault()
          if ($event.target !== $event.currentTarget) return null
          _vm.listShowing = !_vm.listShowing
        },
      },
    },
    [
      _c("i", {
        staticClass: "quick-favorite-icon icon",
        on: {
          click: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "left", 37, $event.key, [
                "Left",
                "ArrowLeft",
              ])
            )
              return null
            if ("button" in $event && $event.button !== 0) return null
            return _vm.toggle()
          },
          contextmenu: function ($event) {
            $event.preventDefault()
            _vm.listShowing = !_vm.listShowing
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "text",
          on: {
            click: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "left", 37, $event.key, [
                  "Left",
                  "ArrowLeft",
                ])
              )
                return null
              if ("button" in $event && $event.button !== 0) return null
              return _vm.toggle()
            },
            contextmenu: function ($event) {
              $event.preventDefault()
              _vm.listShowing = !_vm.listShowing
            },
          },
        },
        [_vm._v("\n    快速收藏\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "selectList",
          staticClass: "select-list",
          class: { show: _vm.listShowing },
        },
        [
          _c(
            "div",
            { staticClass: "lists" },
            [
              _vm._v("\n      选择快速收藏夹:\n      "),
              _c("VDropdown", {
                attrs: { items: _vm.list, "key-mapper": (it) => it.id },
                on: { change: _vm.saveFavoriteList },
                model: {
                  value: _vm.selectedFavoriteList,
                  callback: function ($$v) {
                    _vm.selectedFavoriteList = $$v
                  },
                  expression: "selectedFavoriteList",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "lists-tip", class: { show: _vm.listShowing } },
            [_vm._v("右键点击快速收藏可再次打开")]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "tip", class: { show: _vm.tipShowing } }, [
        _vm._v(_vm._s(_vm.tipText)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }